import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ForgottenPasswordRequest, ForgottenPasswordResponse, ApiService, ValidationResponse, ApiResponse } from "../../services/ApiService";
import AuthValidation from "../../models/validation/AuthValidation";
import { CookieService } from './../../services/CookieService';
import { Router } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-forgottenpassword',
  templateUrl: './forgottenpassword.component.html',
  styleUrls: ['./forgottenpassword.component.scss']
})
export class ForgottenPasswordPageComponent implements OnInit {

  model: ForgottenPasswordRequest;
  show_error: boolean = false;
  error_text: string = "";
  is_loading: boolean = false;

  constructor(private ref: ChangeDetectorRef, private router: Router, private apiService: ApiService, private cookieService: CookieService) { }

  ngOnInit(): void {
    this.cookieService.Redirect(this.router, "forgot-pass");
    this.model = new ForgottenPasswordRequest("");
  }

  /**
   * Called when the 'Request Reset' button is pressed.
   */
  resetPressed(): void {
    let modelValid: ValidationResponse = this.model.isValid();
    if (!modelValid.isSuccess) {
      this.show_error = true;
      this.error_text = modelValid.error;
      return;
    }

    // Send the reset request
    this.show_error = false;
    this.is_loading = true;
    this.apiService.authToken = "";
    this.apiService.SendRequest<ForgottenPasswordResponse>(this.model,
      (response: ApiResponse<ForgottenPasswordResponse>) => {
        if (response.isSuccess) {
          this.cookieService.SetValue("ForgotPassAuthToken", response.values.token);
          this.router.navigate(["/forgot-pass-complete"]);
          return true;
        } else {
          this.show_error = true;
          this.error_text = response.getPrimaryErrorMessage();
        }
        this.is_loading = false;
        this.ref.detectChanges();
        return false;
      }
    );
  }
}
